<style lang="scss">
.delete-dialog-card {
  padding: 20px;
  .headline {
    font-size: 14px !important;
    margin-bottom: 20px;
  }
  button {
    width: 86px;
    height: 40px;
    border-radius: 8px;
    padding: 8px 0;
    font-size: 14px;
    &.close-dialog {
      border: solid 1px #173d8f;
      color: #173d8f;
    }
    &.delete {
      background-color: #d9390d;
      color: #ffffff;
    }
  }
}
</style>

<template>
  <v-dialog v-model="deleteDialog" :max-width="maxWidth || 231">
    <v-card class="delete-dialog-card">
      <slot name="title" />
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <button class="close-dialog mr-5" @click="close">
          {{ $t("CLOSE") }}
        </button>
        <button class="delete" @click="deleteItem">{{ $t("DELETE") }}</button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    maxWidth: Number
  },
  data() {
    return {
      deleteDialog: false,
      item: null
    };
  },
  methods: {
    open(item) {
      this.deleteDialog = true;
      this.item = item;
    },
    close() {
      this.deleteDialog = false;
    },
    deleteItem() {
      this.$emit("deleteItem", this.item);
      this.close();
    }
  }
};
</script>
